import * as React from 'react';
import { noop } from '@progress/kendo-react-common';
/** @hidden */
export var usePropOrState = function (prop, defaultValue) {
    var _a = React.useState(defaultValue), state = _a[0], setState = _a[1];
    return prop !== undefined
        ? [prop, noop]
        : [state, setState];
};
//# sourceMappingURL=usePropOrState.js.map